// Define VideoPromotion custom element
class VideoPromotion extends HTMLElement {
  constructor() {
    super();
    this.intervalHolder = null;
  }

  connectedCallback() {
    this.initializeVideoControls();
    this.initializeSwiperOffset();
    this.initializeCustomNavigation();
  }

  disconnectedCallback() {
    if (this.intervalHolder) {
      clearInterval(this.intervalHolder);
    }
  }

  initializeVideoControls() {
    const allPlayBtn = this.querySelectorAll("[play-btn]");
    const allVideo = this.querySelectorAll("video");
    const allVideoCards = this.querySelectorAll(".video-card");
    const swiper = this.querySelector("#us-vs-them-swiper");
    const touchOverlays = this.querySelectorAll("[touch-overlay]");
    let isSwiping = false;

    // Track video ready state for each video
    const videoReadyStates = new WeakMap();

    // Initialize video loading states
    allVideo.forEach((video) => {
      const videoCard = video.closest(".video-card");
      const loadingOverlay = videoCard?.querySelector("[data-loading-overlay]");
      
      // Check if video is already loaded
      if (video.readyState >= 3) {
        videoReadyStates.set(video, true);
      } else {
        videoReadyStates.set(video, false);
      }

      // Listen for video loaded events
      const handleVideoReady = () => {
        videoReadyStates.set(video, true);
        if (loadingOverlay) {
          loadingOverlay.classList.add("hidden");
        }
      };

      video.addEventListener("canplay", handleVideoReady);
      video.addEventListener("loadeddata", handleVideoReady);
    });

    // // Track swiper movement
    // if (swiper) {
    //   swiper.addEventListener("touchstart", () => {
    //     isSwiping = false;
    //     // Enable touch prevention during potential swipe
    //     touchOverlays.forEach((overlay) => {
    //       overlay.style.pointerEvents = "auto";
    //     });
    //   });

    //   swiper.addEventListener("touchmove", () => {
    //     isSwiping = true;
    //   });

    //   swiper.addEventListener("touchend", () => {
    //     setTimeout(() => {
    //       isSwiping = false;
    //       // Disable touch prevention after swipe
    //       touchOverlays.forEach((overlay) => {
    //         overlay.style.pointerEvents = "none";
    //       });
    //     }, 100);
    //   });
    // }

    allPlayBtn.forEach((item) => {
      // Prevent touch event propagation
      item.addEventListener("touchstart", (e) => {
        e.stopPropagation();
      });

      item.addEventListener("touchend", (e) => {
        e.stopPropagation();
        e.preventDefault();

        // Don't trigger if swiping
        if (isSwiping) return;

        clearInterval(this.intervalHolder);
        this.intervalHolder = null;

        const iconPlay = item.querySelector("[icon-play]");
        const iconPause = item.querySelector("[icon-pause]");
        const videoCard = e.target.closest(".video-card");
        const video = videoCard.querySelector("video");

        if (iconPlay.classList.contains("hidden")) {
          // Pause video
          video.pause();
          iconPlay.classList.remove("hidden");
          iconPause.classList.add("hidden");
          videoCard.classList.remove("playing");
          videoCard.classList.remove("show-controls");
          
          // Hide loading overlay when pausing
          const loadingOverlay = videoCard.querySelector("[data-loading-overlay]");
          if (loadingOverlay) {
            loadingOverlay.classList.add("hidden");
          }
        } else {
          // Pause all videos first
          allVideo.forEach((v) => {
            v.pause();
            v.muted = true;
          });

          // Reset all play buttons and video card states
          allPlayBtn.forEach((btn) => {
            btn.querySelector("[icon-play]").classList.remove("hidden");
            btn.querySelector("[icon-pause]").classList.add("hidden");
          });

          // Hide all loading overlays
          allVideoCards.forEach((card) => {
            card.classList.remove("playing");
            card.classList.remove("show-controls");
            const overlay = card.querySelector("[data-loading-overlay]");
            if (overlay) {
              overlay.classList.add("hidden");
            }
          });

          // Play this video
          const loadingOverlay = videoCard.querySelector("[data-loading-overlay]");
          
          // Show loading if video not ready
          if (!videoReadyStates.get(video) && loadingOverlay) {
            loadingOverlay.classList.remove("hidden");
          }

          video.muted = false;
          video.play().catch((error) => {
            console.error("Play failed:", error);
            if (loadingOverlay) {
              loadingOverlay.classList.add("hidden");
            }
          });
          
          iconPlay.classList.add("hidden");
          iconPause.classList.remove("hidden");
          videoCard.classList.add("playing");

          // On mobile, show controls temporarily
          if ("ontouchstart" in window) {
            videoCard.classList.add("show-controls");
            setTimeout(() => {
              videoCard.classList.remove("show-controls");
            }, 3000); // Hide controls after 3 seconds
          }
        }
      });

      // Keep click event for desktop
      item.addEventListener("click", (event) => {
        // Skip if on touch device
        if ("ontouchstart" in window) return;

        clearInterval(this.intervalHolder);
        this.intervalHolder = null;

        const iconPlay = item.querySelector("[icon-play]");
        const iconPause = item.querySelector("[icon-pause]");
        const videoCard = event.target.closest(".video-card");
        const video = videoCard.querySelector("video");

        if (iconPlay.classList.contains("hidden")) {
          // Pause video
          video.pause();
          iconPlay.classList.remove("hidden");
          iconPause.classList.add("hidden");
          videoCard.classList.remove("playing");
          
          // Hide loading overlay when pausing
          const loadingOverlay = videoCard.querySelector("[data-loading-overlay]");
          if (loadingOverlay) {
            loadingOverlay.classList.add("hidden");
          }
        } else {
          // Pause all videos first
          allVideo.forEach((v) => {
            v.pause();
            v.muted = true;
          });

          // Reset all play buttons and video card states
          allPlayBtn.forEach((btn) => {
            btn.querySelector("[icon-play]").classList.remove("hidden");
            btn.querySelector("[icon-pause]").classList.add("hidden");
          });

          // Hide all loading overlays
          allVideoCards.forEach((card) => {
            card.classList.remove("playing");
            const overlay = card.querySelector("[data-loading-overlay]");
            if (overlay) {
              overlay.classList.add("hidden");
            }
          });

          // Play this video
          const loadingOverlay = videoCard.querySelector("[data-loading-overlay]");
          
          // Show loading if video not ready
          if (!videoReadyStates.get(video) && loadingOverlay) {
            loadingOverlay.classList.remove("hidden");
          }

          video.muted = false;
          video.play().catch((error) => {
            console.error("Play failed:", error);
            if (loadingOverlay) {
              loadingOverlay.classList.add("hidden");
            }
          });
          
          iconPlay.classList.add("hidden");
          iconPause.classList.remove("hidden");
          videoCard.classList.add("playing");
        }
      });
    });

    // Add click handler for video cards to pause when playing
    allVideoCards.forEach((card) => {
      // Desktop click handler
      card.addEventListener("click", (e) => {
        // Skip if on touch device or clicking on play button
        if ("ontouchstart" in window || e.target.closest("[play-btn]")) return;

        // Only handle if video is playing
        if (card.classList.contains("playing")) {
          e.preventDefault();
          e.stopPropagation();

          const video = card.querySelector("video");
          const playBtn = card.querySelector("[play-btn]");
          const iconPlay = playBtn.querySelector("[icon-play]");
          const iconPause = playBtn.querySelector("[icon-pause]");
          const loadingOverlay = card.querySelector("[data-loading-overlay]");

          // Pause the video
          video.pause();
          iconPlay.classList.remove("hidden");
          iconPause.classList.add("hidden");
          card.classList.remove("playing");
          
          // Hide loading overlay
          if (loadingOverlay) {
            loadingOverlay.classList.add("hidden");
          }
        }
      });

      // Mobile touch handler
      if ("ontouchstart" in window) {
        let touchStartTime = 0;
        let isTap = false;

        card.addEventListener("touchstart", (e) => {
          touchStartTime = Date.now();
          isTap = true;
        });

        card.addEventListener("touchmove", () => {
          isTap = false;
        });

        card.addEventListener("touchend", (e) => {
          const touchDuration = Date.now() - touchStartTime;

          // Consider it a tap if duration is less than 200ms and no movement
          if (isTap && touchDuration < 200 && card.classList.contains("playing") && !e.target.closest("[play-btn]")) {
            e.preventDefault();
            e.stopPropagation();

            const video = card.querySelector("video");
            const playBtn = card.querySelector("[play-btn]");
            const iconPlay = playBtn.querySelector("[icon-play]");
            const iconPause = playBtn.querySelector("[icon-pause]");
            const loadingOverlay = card.querySelector("[data-loading-overlay]");

            // Pause the video
            video.pause();
            iconPlay.classList.remove("hidden");
            iconPause.classList.add("hidden");
            card.classList.remove("playing");
            card.classList.remove("show-controls");
            
            // Hide loading overlay
            if (loadingOverlay) {
              loadingOverlay.classList.add("hidden");
            }
          }
        });
      }
    });

    // Reset video currentTime every 5 seconds
    this.intervalHolder = setInterval(() => {
      allVideo.forEach((item) => {
        item.currentTime = 0;
      });
    }, 5000);
  }

  initializeSwiperOffset() {
    const usVsThemSwiper = this.querySelector("#us-vs-them-swiper");
    const usVsThemLoading = this.querySelector("#us-vs-them-loading");

    if (!usVsThemSwiper) return;

    // Calculate slides-offset-before value
    function calculateSlidesOffset() {
      const screenWidth = window.innerWidth;
      let offsetBefore = 0;

      if (screenWidth > 1280) {
        offsetBefore = (screenWidth - 1280) / 2;
      } else {
        offsetBefore = 24;
      }

      return offsetBefore;
    }

    // Set initial swiper offset
    const offsetValue = calculateSlidesOffset();
    usVsThemSwiper.setAttribute("slides-offset-before", offsetValue);

    // Update offset on window resize
    const resizeHandler = () => {
      const newOffsetValue = calculateSlidesOffset();
      usVsThemSwiper.setAttribute("slides-offset-before", newOffsetValue);
    };

    window.addEventListener("resize", resizeHandler);

    // Initialize swiper
    if (usVsThemSwiper.initialize) {
      usVsThemSwiper.initialize();
    }

    if (usVsThemLoading) {
      usVsThemLoading.style.display = "none";
    }

    usVsThemSwiper.classList.add("opacity-100");
  }

  initializeCustomNavigation() {
    const swiperElement = this.querySelector('#us-vs-them-swiper');
    const prevButton = this.querySelector('[data-swiper-prev]');
    const nextButton = this.querySelector('[data-swiper-next]');

    if (!swiperElement || !prevButton || !nextButton) {
      console.log('Swiper or navigation buttons not found');
      return;
    }

    console.log('Found navigation buttons, initializing...');

    // Prevent duplicate binding
    if (prevButton.hasAttribute('data-nav-initialized')) {
      console.log('Navigation already initialized');
      return;
    }

    prevButton.setAttribute('data-nav-initialized', 'true');
    nextButton.setAttribute('data-nav-initialized', 'true');

    // Previous button click handler
    const handlePrevClick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const swiperInstance = swiperElement.swiper;
      if (swiperInstance && typeof swiperInstance.slidePrev === 'function') {
        swiperInstance.slidePrev();
      }
    };

    // Next button click handler
    const handleNextClick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const swiperInstance = swiperElement.swiper;
      if (swiperInstance && typeof swiperInstance.slideNext === 'function') {
        swiperInstance.slideNext();
      }
    };

    // Bind event listeners
    prevButton.addEventListener('click', handlePrevClick);
    nextButton.addEventListener('click', handleNextClick);
  }
}

// Register the custom element
if (!customElements.get("video-promotion")) {
  customElements.define("video-promotion", VideoPromotion);
}
